export const ErrorMsg = ({ message }) => {
  return (
    <div>
      <span className="text-xs text-center font-medium text-redColor">{message}</span>
    </div>
  );
};
